export class Midi {
    constructor(meta) {
        // All tracks.
        this.tracks = [];
        /**
         * - type: 0 (single-track) or 1 (multi-track).
         * - trackCount: 1 for type 0, 2+ for type 1
         */
        this.meta = null;
        this.meta = meta;
    }
}
